import type { GetEventsByTeamIdParams } from './params'
import { eventApi } from './client'

export const getEventsByTeamId = ({ teamId }: GetEventsByTeamIdParams) =>
  eventApi.get(`/get-by-team/${teamId}`)
